import styled, { keyframes } from 'styled-components';
import ICoresData from '../../context/ICoresData';
import { CircularProgress, TextField } from '@material-ui/core';

interface CoresProps {
  cores: ICoresData;
}

const surgirDeCima = keyframes`
  from {
    opacity: 0;
    transform: translateY(-100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  from {
      opacity: 0;
      transform: translateY(-20px);
  }
  to {
      opacity: 1;
      transform: translateY(0);
  }
`;

export const Container = styled.div<CoresProps>`
  display: flex;
  flex-direction: column;

  .MuiTextField-root {
    /* contorno do input */
    & .MuiOutlinedInput-root {
      fieldset {
        &.MuiOutlinedInput-notchedOutline {
          border-color: ${props => props.cores.secundaria} !important;
        }
      }
    }
    /* Contorno do input no hover */
    &:hover {
      & .MuiOutlinedInput-root {
        fieldset {
          &.MuiOutlinedInput-notchedOutline {
            border-color: ${props => props.cores.secundariaShade} !important;
          }
        }
      }
    }
    /* contorno quando foca no input */
    & .MuiOutlinedInput-root {
      &.Mui-focused fieldset {
        border-color: ${props => props.cores.secundariaShade} !important;
      }
    }
    /* cor da fonte do input */
    & .MuiOutlinedInput-input {
      color: ${props => props.cores.texto} !important;
      /* letra maiúscula no input */
      text-transform: uppercase;
    }
    /* label quando preenchido */
    & label.MuiFormLabel-filled {
      color: ${props => props.cores.secundaria} !important;
    }
    /* label em cima do input */
    & label.Mui-focused {
      color: ${props => props.cores.secundariaShade} !important;
    }
    /* seria o placeholder */
    > label {
      color: ${props => props.cores.textoClaro};
    }
  }
`;

export const Header = styled.header<CoresProps>`
  /* fixar na tela */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;

  padding: 16px 0;
  background: ${props => props.cores.primaria};
  /* width: auto; */
  flex: 1;

  animation: ${surgirDeCima} 1s;

  border-bottom: ${props =>
    props.cores.textoCabecalho
      ? `2px solid ${props.cores.textoCabecalho}`
      : ''};

  height: 110px;
  @media (max-width: 610px) {
    height: 80px;
  }
`;

export const HeaderContent = styled.div<CoresProps>`
  max-width: 1120px;
  /* dá uma alinhada no centro no header content */
  margin: 0 auto;
  display: flex;
  align-items: center;

  @media (max-width: 1150px) {
    margin: 0 24px;
  }

  /* estiliza a primeira imagem: a logo */
  a {
    img {
      height: 80px;
      @media (max-width: 610px) {
        height: 56px;
      }
      cursor: pointer;
    }
  }
`;

export const CirculoCarregandoDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const CirculoCarregando = styled(CircularProgress)<CoresProps>`
  color: #e6e600 !important;
  color: ${props => props.cores.secundaria} !important;

  width: 80px !important;
  height: 80px !important;
  @media (max-width: 610px) {
    width: 40px !important;
    height: 40px !important;
  }
`;

export const Content = styled.main`
  max-width: 1120px;
  min-height: 600px;
  width: 100%;
  margin: 0 auto;

  margin-top: 110px;
  @media (max-width: 610px) {
    margin-top: 80px;
  }

  padding-left: 8px;
  padding-right: 8px;
`;

export const GroupBox = styled.fieldset<CoresProps>`
  border: 1px solid ${props => props.cores.secundaria} !important;
  border-radius: 10px;
  padding: 0 20px 15px !important;
  margin: 25px 0;

  height: 100%;

  span {
    @media (min-width: 768px) {
      display: flex;
      flex-direction: row;
    }
  }

  h3 {
    margin-top: 10px;
    color: ${props => props.cores.secundaria};
  }
`;

export const GroupBoxLegenda = styled.legend`
  font-size: 20px !important;
  text-align: left !important;
  color: #c4cc45;
  width: auto;
  padding: 0px 5px;
  border-bottom: none;
`;

export const BoxCadastro = styled.div`
  animation: ${fadeIn} 1s;
  margin-top: 40px;

  max-width: 800px;
  margin-left: auto;
  margin-right: auto;

  border-radius: 8px;

  padding: 0 8px;

  div {
    display: flex;
  }
`;

export const InputDescricao = styled(TextField)`
  flex: 2;

  @media (min-width: 768px) {
    margin-right: 8px !important;
  }
`;

export const InputNcm = styled(TextField)`
  flex: 3;

  @media (min-width: 768px) {
    margin-right: 8px !important;
  }
`;

export const InputCusto = styled(TextField)`
  flex: 1.5;

  @media (min-width: 768px) {
    margin-right: 8px !important;
  }
`;

export const InputGrupo = styled(TextField)`
  flex: 1;
`;

export const InputUm = styled(TextField)`
  flex: 1;

  @media (min-width: 768px) {
    margin-right: 8px !important;
  }
`;

export const InputPreco = styled(TextField)`
  flex: 1.5;

  @media (min-width: 768px) {
    margin-right: 8px !important;
  }
`;

export const CheckboxDestaque = styled.label<CoresProps>`
  display: flex;
  cursor: pointer;
  margin-top: 5px;

  @media (min-width: 768px) {
    align-items: center;
    justify-content: center;
  }

  input {
    appearance: none;
    margin-right: 5px;
    width: 16px;
    height: 16px;
    border: 2px solid ${props => props.cores.secundaria};
    border-radius: 4px;
    background-color: white;
    transition: background-color 0.3s, border-color 0.3s;

    :checked {
      background-color: ${props => props.cores.secundaria};
      border-color: ${props => props.cores.secundaria};
    }

    :checked::after {
      content: '✔';
      color: white;
      font-size: 12px;
      text-align: center;
      display: block;
      position: relative;
      top: -2px;
    }
  }
`;

export const InputDescricaoPesq = styled(TextField)`
  flex: 3;

  @media (min-width: 768px) {
    margin-right: 8px !important;
  }
`;

export const InputGrupoPesq = styled(TextField)`
  flex: 1;

  @media (min-width: 768px) {
    margin-right: 8px !important;
  }
`;

export const PesquisaButton = styled.div<CoresProps>`
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  flex: 0.3;
  height: 56px;

  margin-top: 15px;

  border: 2px solid ${props => props.cores.secundaria};
  border-radius: 8px;
  background-color: #fff;

  svg {
    height: 25px;
    width: 25px;
    color: ${props => props.cores.secundaria};
  }

  &:hover {
    background-color: ${props => props.cores.secundaria};

    svg {
      color: #fff;
    }
  }

  @media (min-width: 768px) {
    width: 100%;
  }
`;

export const ContainerPesquisa = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 10px;
  gap: 8px;

  overflow-y: auto;

  height: 50vh;
`;

export const CardProduto = styled.div<CoresProps>`
  cursor: pointer;

  display: flex;
  flex-direction: column;

  border: 1px solid ${props => props.cores.secundaria};
  border-radius: 8px;
  padding: 8px;

  margin-right: 8px;
  position: relative;

  h4 {
    color: ${props => props.cores.secundaria};
    font-weight: 500;

    margin-bottom: 8px;
  }
`;

export const CardDestaque = styled.div<{ destaque: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  visibility: ${props => (props.destaque ? 'visible' : 'hidden')};

  width: 30px;
  height: 30px;
  border-radius: 100%;

  background-color: gold;
  color: white;

  position: absolute;
  right: 10px;
  top: 25%;

  svg {
    fill: white;
  }
`;

export const BotaoSalvar = styled.div<CoresProps>`
  animation: ${fadeIn} 1s;
  width: 100%;
  height: 40px;
  display: flex;
  margin-top: 5px;

  button {
    background: ${props => props.cores.secundaria};
    border-radius: 8px 8px 8px 8px;
    border: none;
    flex: 1;
    /* width: 100%; */

    height: 30px;
    color: #fff;

    transition: color 0.3s;
    transition: background-color 0.1s;

    &:hover {
      background-color: ${props => props.cores.secundariaShade};
    }

    &:active {
      background-color: ${props => props.cores.primaria};
    }

    div {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      svg {
        height: 20px;
        width: 20px;
        margin-right: 4px;
      }

      span {
        font-size: 18px;
      }
    }
  }
`;
